import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getHistoricalActivities } from "../common/services";

export const MGM_HISTORY_PAGE_SIZE = 3;

export function mgmHistoryLoader() {
  return defer({
    coreData: resolveLoaderResult(
      getHistoricalActivities({
        pageNum: 1,
        pageSize: MGM_HISTORY_PAGE_SIZE,
      }),
    ),
  });
}
